import type { ButtonNode, MenuNode, MenuSchema, TextInputNode, TextNode } from '../MenuSchema.js';

export const ROOMS_MENU_ACTIONS = {
    joinRoom: 'rooms-join-room',
    refreshRooms: 'rooms-refresh-rooms',
    createRoom: 'rooms-create-room',
} as const;

export const ROOMS_MENU_LABELS = {
    title: 'Rooms',
    currentRoomPrefix: 'Current room:',
    loadingRooms: 'Loading rooms…',
    availableRooms: 'Available rooms:',
    roomName: 'Room name:',
    roomNamePlaceholder: 'Enter room name',
    password: 'Password:',
    roomPassword: 'Room Password',
    passwordPlaceholder: 'Enter room password',
    createPasswordLabel: 'Room Password (optional)',
    createPasswordPlaceholder: 'Leave blank for public room',
    joinCreateRoom: 'Join / Create Room',
    joinRoom: 'Join Room',
    refreshList: 'Refresh List',
    refresh: 'Refresh',
    createNewRoom: 'Create New Room',
    createJoinRoom: 'Create / Join Room',
    noActiveRooms: 'No active rooms.',
    failedToLoadRooms: 'Failed to load rooms.',
    errorLoadingRooms: 'Error loading rooms.',
    notAuthenticated: 'Not authenticated.',
} as const;

export function createRoomsMenuSchema(): MenuSchema {
    return {
        id: 'ROOMS',
        title: ROOMS_MENU_LABELS.title,
        nodes: [
            { type: 'text', text: ROOMS_MENU_LABELS.availableRooms },
            { type: 'input', id: 'rooms-name-input', placeholder: ROOMS_MENU_LABELS.roomNamePlaceholder, get: () => '' },
            { type: 'input', id: 'rooms-password-input', placeholder: ROOMS_MENU_LABELS.passwordPlaceholder, get: () => '' },
            { type: 'button', id: ROOMS_MENU_ACTIONS.joinRoom, label: ROOMS_MENU_LABELS.joinCreateRoom },
            { type: 'button', id: ROOMS_MENU_ACTIONS.refreshRooms, label: ROOMS_MENU_LABELS.refreshList },
            { type: 'button', id: ROOMS_MENU_ACTIONS.createRoom, label: ROOMS_MENU_LABELS.createJoinRoom },
        ],
    };
}

function findSchemaNodeById(schema: MenuSchema, id: string): MenuNode | undefined {
    return schema.nodes.find((n) => (n as { id?: string }).id === id);
}

export function readRoomsSchemaButtonLabel(schema: MenuSchema, id: string, fallback: string): string {
    const node = findSchemaNodeById(schema, id) as ButtonNode | undefined;
    if (!node || node.type !== 'button') {
        return fallback;
    }
    return typeof node.label === 'function' ? node.label() : node.label;
}

export function readRoomsSchemaInputPlaceholder(schema: MenuSchema, id: string, fallback: string): string {
    const node = findSchemaNodeById(schema, id) as TextInputNode | undefined;
    if (!node || node.type !== 'input') {
        return fallback;
    }
    return node.placeholder || fallback;
}

export function readRoomsSchemaTextAt(schema: MenuSchema, index: number, fallback: string): string {
    const textNodes = schema.nodes.filter((n): n is TextNode => n.type === 'text');
    const node = textNodes[index];
    if (!node) {
        return fallback;
    }
    return typeof node.text === 'function' ? node.text() : node.text;
}
